export var AutomationErrorTypes = /*#__PURE__*/ function(AutomationErrorTypes) {
    AutomationErrorTypes["DuplicateAutomation"] = "CONFLICTING_FIELD_VALUE";
    return AutomationErrorTypes;
}({});
export var ThirdpartyIntegrationType = /*#__PURE__*/ function(ThirdpartyIntegrationType) {
    ThirdpartyIntegrationType["Slack"] = "slack";
    ThirdpartyIntegrationType["Jira"] = "jira";
    ThirdpartyIntegrationType["Salesforce"] = "salesforce";
    ThirdpartyIntegrationType["Rocketlane"] = "rocketlane";
    ThirdpartyIntegrationType["Form"] = "FORM";
    return ThirdpartyIntegrationType;
}({});
